import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import { Formik } from "formik";
import "../../../styles/Layout/Admin_Styles/_AdminResetPassword.scss";
import { IconButton, Tooltip } from "@mui/material";
import REGEXS from "../../../utils/regex";
import { decrypt, encrypt } from "../../../utils/encryptDecrypt";
import { authHttp } from "../../services/utility";
import { apisPath } from "../../../utils/path";
import { AuthContext } from "../../../context/AuthContext";
import { useContext } from "react";

export default function AdminResetPassword(_props) {
  const [showPassword, setShowPassword] = React.useState(false);
  const { setIsLoading, setAlertState, setToastState } =
    useContext(AuthContext);

  const { open, resetHandleClose, actionData } = _props;

  const defaultValues = {
    user_id: '',
    password: "",
    confirm_password: "",
  };

  const AdminResetSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .matches(
        REGEXS?.password,
        "Password must contain at least 8 and maximum 20 characters including at least 1 uppercase, 1 lowercase, one number and one special character(@#^`~$!%*?&)."
      ),
    confirm_password: Yup.string()
      .when("password", (password, schema) => {
        if (password !== undefined) {
          return schema.required("Confirm Password is required");
        }
        return schema;
      })
      .oneOf([Yup.ref("password"), null], "Password must match"),
  });

  const submitHandler = async (data, { resetForm }) => {
    setIsLoading(true);
    const tempData = { ...data }
    tempData.user_id = encrypt(actionData?.id)
    tempData.password = encrypt(tempData.password)
    tempData.confirm_password = encrypt(tempData.confirm_password)
    authHttp.post(apisPath?.admin?.resetPassword, tempData).then((res) => {
      resetForm()
      setIsLoading(false);
      resetHandleClose()
      setToastState((prev) => ({ ...prev, open: true, msg: res?.data?.msg }));
    }).catch(err => {
      resetForm()
      setIsLoading(false);
      setAlertState((prev) => ({
        ...prev,
        open: true,
        title: err?.response?.data?.msg,
        btnTxt: "CLOSE",
        status: "fail",
        isSessionExpire: err?.response?.status === 401,
        sessionType: "admin",
      }));
    })
  };

  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="admin-reset--password">
          <div className="admin-reset--password__info">
            <div className="admin-reset--password__header">
              <h2>Reset Password  <span>({decrypt(actionData?.name)})</span></h2>
             
            </div>
            <div className="admin-reset--password__icon">
              <Tooltip title="Close" onClick={()=>{
                resetHandleClose(actionData?.selectedModal)
              }}>
                <IconButton>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Formik
            initialValues={defaultValues}
            validationSchema={AdminResetSchema}
            onSubmit={submitHandler}
          >
            {({
              handleChange,
              values,
              handleSubmit,
              errors,
              touched,
              handleBlur,
              dirty,
              isValid,
              isSubmitting,
            }) => (
              <div className="admin-reset--password__form">
                <div className="admin-reset--password__textfield">
                  <FormControl fullWidth variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-password">
                      Password
                    </InputLabel>
                    <OutlinedInput
                      id="password"
                      type={showPassword ? "text" : "password"}
                      value={values?.password}
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyUp={handleBlur}
                      onPaste={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                      label="Password"
                    />
                  </FormControl>
                  {errors.password && touched.password && (
                    <p className="text-danger">{errors.password}</p>
                  )}
                </div>
                <div className="admin-reset--password__textfield">
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="confirm_password"
                    id="confirm_password"
                    label="Confirm Password"
                    type="password"
                    value={values?.confirm_password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onKeyUp={handleBlur}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                  />
                  {errors?.confirm_password && touched?.confirm_password && (
                    <p className="text-danger">{errors?.confirm_password}</p>
                  )}
                </div>
                <div
                  className="admin-reset--password__button"
                  onClick={handleSubmit}
                >
                  <Button
                    variant="contained"
                    disabled={!(isValid && dirty) || isSubmitting}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            )}
          </Formik>
        </Box>
      </Modal>
    </div>
  );
}
